const internals = {};

internals.buildSortOptions = (ALL_GROUPS_SORT_TYPE) => ([
    {
        value: ALL_GROUPS_SORT_TYPE.BY_DATE_UPDATED,
        label: 'Newest Chat'
    },
    {
        value: ALL_GROUPS_SORT_TYPE.BY_NAME,
        label: 'Group Name'
    }
]);

internals.buildFields = ({
    ALL_GROUPS_SORT_TYPE,
    canCreateGroups,
    onSortChange,
    renderCreateAction,
    selectFieldStyles
} = {}) => ([
    {
        type: 'group',
        fields: [
            {
                type: 'SelectField',
                name: 'sortType',
                label: 'Show By',
                options: internals.buildSortOptions(ALL_GROUPS_SORT_TYPE),
                onChange: onSortChange,
                textFieldProps: {
                    variant: 'filled',
                    fieldStyles: selectFieldStyles,
                    InputLabelProps: {
                        shrink: true
                    },
                    InputProps: {
                        disableUnderline: true
                    },
                    inputProps: {
                        'aria-label': 'Show By'
                    }
                }
            },
            canCreateGroups && {
                type: 'custom',
                render: renderCreateAction
            }
        ].filter(Boolean)
    }
]);

module.exports.buildDefaults = function buildDefaults({
    allGroupsSortType,
    ALL_GROUPS_SORT_TYPE
} = {}) {

    return {
        sortType: allGroupsSortType || ALL_GROUPS_SORT_TYPE.BY_DATE_UPDATED
    };
};

module.exports.buildFormConfig = function buildFormConfig(props) {

    const {
        ALL_GROUPS_SORT_TYPE,
        allGroupsSortType,
        canCreateGroups,
        onSortChange,
        onSubmit
    } = props;

    return {
        formId: 'my-groups-filter-form',
        fields: internals.buildFields({
            ALL_GROUPS_SORT_TYPE,
            canCreateGroups,
            onSortChange,
            renderCreateAction: props.renderCreateAction,
            selectFieldStyles: props.selectFieldStyles
        }),
        defaults: module.exports.buildDefaults({
            allGroupsSortType,
            ALL_GROUPS_SORT_TYPE
        }),
        onSubmit
    };
};
module.exports.internals = internals;
